import { useState } from 'react'
import './TaskForm.css'

export default function TaskForm({ addTask }) {
  const [description, setDescription] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!description.trim()) return

    setIsSubmitting(true)
    await addTask(description.trim())
    setDescription('')
    setIsSubmitting(false)
  }

  return (
    <form className="task-form" onSubmit={handleSubmit}>
      <div className="input-group">
        <input
          type="text"
          className="task-input"
          placeholder="What needs to be done?"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          disabled={isSubmitting}
        />
        <button 
          type="submit" 
          className={`add-button ${isSubmitting ? 'loading' : ''}`}
          disabled={!description.trim() || isSubmitting}
        >
          {isSubmitting ? (
            <div className="button-spinner"></div>
          ) : (
            <span>+</span>
          )}
        </button>
      </div>
    </form>
  )
}